let latestId = 1;
export const getNextId = () => ++latestId;
export const resetIdGenerator = (shapes) => {
    latestId = (shapes === null || shapes === void 0 ? void 0 : shapes.length) ? Math.max(...shapes.map(({ id }) => id)) : 1;
};
//# sourceMappingURL=id-generator.js.map